"use client";

import { motion, AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";

export default function DeleteModal({
  isOpen,
  onClose,
  onConfirm,
  fileName,
  sectionName,
}) {
  const { isDeleting } = useSelector((state) => state.application);

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          className="bg-white rounded-lg p-6 max-w-md w-full"
        >
          <h3 className="text-lg font-medium mb-4">Confirm Delete</h3>
          <p className="text-gray-600 mb-6">
            Are you sure you want to delete {fileName} from {sectionName}?
          </p>
          <div className="flex justify-end space-x-4">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
            >
              Cancel
            </button>
            {isDeleting ? (
              <button
              disabled
              className="px-4 py-2 bg-red-600 rounded-full w-[83px] h-[40px] flex justify-center items-center text-white"
              >
                <span className="loader"></span>
              </button>
            ) : (
              <button
                onClick={async()=>{await onConfirm()}}
                className="px-4 py-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors"
              >
                Delete
              </button>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
